/** Phaser texture keys (see KaperScene IMAGE_MANIFEST). */
export const TextureKey = Object.freeze({
  SHIP_BOARD_EN: 'ship-board-en',
  SHIP_BOARD_DA: 'ship-board-da',
  FLAG_POLE: 'flag-pole',
  FLAG_PIRATE: 'flag-pirate',
  FLAG_EN: 'flag-en',
  SHOOT: 'shoot',
  SHOOT_WIND: 'shoot-wind',
  SHOOT_CROSS: 'shoot-cross',
  SHOOT_HIT: 'shoot-hit',
  SHOOT_MISS1: 'shoot-miss1',
});
